import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faMagnifyingGlass } from "@fortawesome/free-solid-svg-icons";

interface Props {
  search: string;
  onSearchChange: (v: string) => void;
}

export default function GoalsSearchBar({
  search,
  onSearchChange,
}: Readonly<Props>) {
  return (
    <div className="goal-search-bar">
      <FontAwesomeIcon icon={faMagnifyingGlass} className="search-icon" />
      <input
        type="text"
        aria-label="Search goals"
        className="filter-input"
        placeholder="Search goals ..."
        value={search}
        onChange={(e) => onSearchChange(e.target.value)}
      />
    </div>
  );
}
